<!-- Module rail — Carot ERP v2 (module-rail.jsx :: ModuleRail), đặt ở MÉP TRÁI shell (Q-061), viền phải; tooltip mở sang phải.
     Nền trắng, vạch chia cụm hairline, icon nét mảnh của thiết kế (sprite rail, Alex chốt 31/10),
     icon tắt xám, mục đang chọn = nền hồng nhạt + icon hồng
     (ngoại lệ "chọn = ink" do Alex chốt cho điều hướng shell). KHÔNG vạch màu một cạnh.
     Logic gate giữ nguyên: mỗi mục bọc *hasResource, mục mờ khi tài khoản chưa có tenant. -->
<nav role="navigation" aria-label="Module navigation" class="module-rail-nav no-scrollbar">
  <!-- Bối cảnh (tenant / đơn vị / cơ sở): ô vuông 32 bo 10 + mũi tên — module-rail.jsx. -->
  <button
    type="button"
    class="module-rail-ctx"
    [dsTooltip]="ctxTooltip || ('BusinessUnit.SelectUnit' | translate)"
    dsTooltipPosition="right"
    [dsTooltipDisabled]="ctxPanelOpen()"
    [attr.aria-label]="ctxTooltip || ('BusinessUnit.SelectUnit' | translate)"
    (click)="onCoreClick()"
  >
    <span class="module-rail-ctx-badge">
      @if (ctxInitials) {
        {{ ctxInitials }}
      } @else {
        <span class="material-symbols-outlined icon-size-token-sm" aria-hidden="true">
          storefront
        </span>
      }
    </span>
    <svg class="module-rail-ctx-chevron" aria-hidden="true" focusable="false">
      <use [attr.href]="chevronHref"></use>
    </svg>
  </button>

  @for (group of groups; track group.id; let last = $last) {
    <div class="module-rail-group" [class.module-rail-group--last]="last">
      @if (group.shortTitle) {
        <span class="module-rail-group-label">{{ group.shortTitle }}</span>
      }
      @for (item of group.children; track item.id) {
        <ng-container *hasResource="item.id || ''">
          @if (!item.externalLink) {
            <a
              [routerLink]="isItemDisabled(item) ? null : item.link"
              [queryParamsHandling]="'preserve'"
              routerLinkActive="module-rail-active"
              #rla="routerLinkActive"
              [attr.aria-current]="rla.isActive ? 'true' : null"
              [attr.aria-label]="item.title || '' | translate"
              [dsTooltip]="item.title || '' | translate"
              dsTooltipPosition="right"
              class="module-rail-item"
              [class.module-rail-item--disabled]="isItemDisabled(item)"
            >
              @if (railIconHref(item); as href) {
                <svg class="module-rail-icon" aria-hidden="true" focusable="false">
                  <use [attr.href]="href"></use>
                </svg>
              } @else {
                <span class="material-symbols-outlined" aria-hidden="true">
                  {{ item.materialIcon || item.icon }}
                </span>
              }
            </a>
          }
          @if (item.externalLink) {
            <a
              [href]="item.link"
              [target]="item.target || '_blank'"
              [attr.aria-label]="item.title || '' | translate"
              [dsTooltip]="item.title || '' | translate"
              dsTooltipPosition="right"
              class="module-rail-item"
              [class.module-rail-item--disabled]="isItemDisabled(item)"
            >
              @if (railIconHref(item); as href) {
                <svg class="module-rail-icon" aria-hidden="true" focusable="false">
                  <use [attr.href]="href"></use>
                </svg>
              } @else {
                <span class="material-symbols-outlined" aria-hidden="true">
                  {{ item.materialIcon || item.icon }}
                </span>
              }
            </a>
          }
        </ng-container>
      }
    </div>
  }
</nav>
